module.exports = __webpack_public_path__ + "static/img/shape_6.0908ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shape_6.png
// module id = kblJ
// module chunks = 0